/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Confirm_Invite_Code_DescriptionInputs */

const en_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can only enter one invite code. This can't be changed once confirmed.`)
};

const ar_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمكن لكل شخص إدخال رمز دعوة واحد فقط. لا يمكن تغييره بعد التأكيد.`)
};

const de_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst nur einen Einladungscode eingeben. Nach der Bestätigung kann er nicht mehr geändert werden.`)
};

const es_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo puedes introducir un código de invitación. No se podrá cambiar una vez confirmado.`)
};

const fr_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous ne pouvez saisir qu’un seul code d’invitation. Il ne pourra plus être modifié une fois confirmé.`)
};

const it_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi inserire un solo codice invito. Non potrà essere modificato dopo la conferma.`)
};

const ja_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力できる招待コードは1つだけです。確認後は変更できません。`)
};

const ko_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대 코드는 하나만 입력할 수 있어요. 확인 후에는 변경할 수 없어요.`)
};

const pt_br_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você só pode inserir um código de convite. Ele não poderá ser alterado após a confirmação.`)
};

const ru_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы можете ввести только один код приглашения. После подтверждения его нельзя будет изменить.`)
};

const th_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณกรอกรหัสเชิญได้เพียงหนึ่งรหัสเท่านั้น เมื่อยืนยันแล้วจะไม่สามารถเปลี่ยนได้`)
};

const tr_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca bir davet kodu girebilirsin. Onaylandıktan sonra değiştirilemez.`)
};

const zh_cn_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个人只能输入一组邀请码，一旦确认即无法更改。`)
};

const zh_tw_dialog_confirm_invite_code_description = /** @type {(inputs: Dialog_Confirm_Invite_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每個人只能輸入一組邀請碼，一旦確認即無法更改。`)
};

/**
* | output |
* | --- |
* | "You can only enter one invite code. This can't be changed once confirmed." |
*
* @param {Dialog_Confirm_Invite_Code_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_confirm_invite_code_description = /** @type {((inputs?: Dialog_Confirm_Invite_Code_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Confirm_Invite_Code_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_confirm_invite_code_description(inputs)
	if (locale === "ar") return ar_dialog_confirm_invite_code_description(inputs)
	if (locale === "de") return de_dialog_confirm_invite_code_description(inputs)
	if (locale === "es") return es_dialog_confirm_invite_code_description(inputs)
	if (locale === "fr") return fr_dialog_confirm_invite_code_description(inputs)
	if (locale === "it") return it_dialog_confirm_invite_code_description(inputs)
	if (locale === "ja") return ja_dialog_confirm_invite_code_description(inputs)
	if (locale === "ko") return ko_dialog_confirm_invite_code_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_confirm_invite_code_description(inputs)
	if (locale === "ru") return ru_dialog_confirm_invite_code_description(inputs)
	if (locale === "th") return th_dialog_confirm_invite_code_description(inputs)
	if (locale === "tr") return tr_dialog_confirm_invite_code_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_confirm_invite_code_description(inputs)
	return zh_tw_dialog_confirm_invite_code_description(inputs)
});